<template>
  <div class="home py-10">
    <h1 class="text-center">Activities for today</h1>
    <div class="text-center pa-5" v-if="!forToday">
      There are no activities scheduled for today.
    </div>
    <v-container v-else>
      <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card class="black--text">
          <v-card-title class="headline">
            Important Notes ({{ notes.length }})
          </v-card-title>

          <v-card-text class="black--text">
            <div v-for="(noteItem, index) in notes" :key="index" class="mb-4">
              <strong>{{ noteItem.businessName }}</strong>
              <template v-if="noteItem.note">
                <div>
                  <br />
                  {{ noteItem.note }}
                  <br />
                </div>
              </template>

              <template v-if="noteItem.dropOffs && noteItem.dropOffs.length">
                <div>
                  <br />
                  <strong>Drop Offs:</strong>
                  <ul>
                    <li
                      v-for="(drop, dropIndex) in noteItem.dropOffs"
                      :key="dropIndex"
                    >
                      {{ drop.extra }}
                    </li>
                  </ul>
                </div>
              </template>
              <hr class="my-4" />
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col cols="12" md="6">
          <v-card color="cyan darken-1" dark>
            <v-card-title class="headline">Clock In</v-card-title>

            <v-card-subtitle v-if="!clockIn"
              >You need to Clock In</v-card-subtitle
            >
            <v-card-subtitle v-else>Clock In completed</v-card-subtitle>

            <v-card-actions v-if="!clockIn">
              <v-btn text @click="clock(9)">Clock In</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <template>
          <v-col cols="12" md="6">
            <v-card color="green darken-1" dark>
              <v-card-title class="headline">Select Truck</v-card-title>

              <!-- Subtítulo dinámico -->
              <v-card-subtitle v-if="!selectedTruck">
                Please select a truck
              </v-card-subtitle>
              <v-card-subtitle v-else>
                Selected: {{ selectedTruck ? selectedTruck.vehicle : "" }}
              </v-card-subtitle>

              <v-card-text>
                <v-select
                  v-if="!assignmentVehicle"
                  v-model="selectedVehicle"
                  :items="vehicles"
                  item-text="vehicle"
                  item-value="id"
                  label="Select Truck"
                ></v-select>
                <div v-else>
                  Truck already assigned:
                  {{ selectedTruck ? selectedTruck.vehicle : "" }}
                </div>
              </v-card-text>

              <!-- Botón solo si hay truck seleccionado -->
              <v-card-actions v-if="selectedTruck && !assignmentVehicle">
                <v-btn text @click="confirmTruck">Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </template>
        <v-col cols="12" md="6">
          <v-card color="amber darken-1" dark>
            <v-card-title class="headline">Pre Trip Inspection</v-card-title>

            <v-card-subtitle v-if="!preTripInspection"
              >You need to complete the Pre Trip Inspection</v-card-subtitle
            >
            <v-card-subtitle v-else
              >Pre Trip Inspection completed</v-card-subtitle
            >

            <v-card-actions v-if="!preTripInspection">
              <v-btn text to="/pre-trip-inspection"
                >Go to Pre Trip Inspection</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card color="orange darken-1" dark>
            <v-card-title class="headline"
              >{{ numContainers }} Containers</v-card-title
            >

            <v-card-subtitle
              >There are {{ numContainers }} containers to pick up
              today.</v-card-subtitle
            >
            <div>
              <ul class="ml-5">
                <li
                  v-for="(item, index) in containersDesc"
                  :key="'el-' + index"
                  v-text="index + ' (' + item + ')'"
                ></li>
              </ul>
            </div>
            <v-card-actions>
              <v-btn text to="/routes">Go to Routes</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card color="blue darken-1" dark>
            <v-card-title class="headline"
              >{{ numNotes }} Notes from Office</v-card-title
            >

            <v-card-subtitle
              >There are {{ numNotes }} notes from office assigned for
              today.</v-card-subtitle
            >
            <div>
              <ul class="ml-5">
                <li
                  v-for="(item, index) in notes"
                  :key="'not-' + index"
                  v-text="item.businessName + ' (' + item.note + ')'"
                ></li>
              </ul>
            </div>
            <v-card-actions>
              <v-btn text to="/routes">Go to Routes</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card color="green darken-1" dark>
            <v-card-title class="headline">{{ numRoutes }} Routes</v-card-title>

            <v-card-subtitle
              >There are {{ numRoutes }} routes to cover today.</v-card-subtitle
            >

            <v-card-actions>
              <v-btn text to="/routes">Go to Routes</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card color="lime darken-1" dark>
            <v-card-title class="headline">Post Trip Inspection</v-card-title>

            <v-card-subtitle v-if="!postTripInspection"
              >You need to complete the Post Trip Inspection</v-card-subtitle
            >
            <v-card-subtitle v-else
              >Post Trip Inspection completed</v-card-subtitle
            >

            <v-card-actions v-if="!postTripInspection">
              <v-btn text to="/post-trip-inspection"
                >Go to Post Trip Inspection</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card color="cyan darken-3" dark>
            <v-card-title class="headline">Clock Out</v-card-title>

            <v-card-subtitle v-if="!clockOut"
              >You need to Clock Out</v-card-subtitle
            >
            <v-card-subtitle v-else>Clock Out completed</v-card-subtitle>

            <v-card-actions v-if="!clockOut">
              <v-btn text @click="clock(10)">Clock Out</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: () => ({
    forToday: false,
    numRoutes: 0,
    numContainers: 0,
    numNotes: 0,
    preTripInspection: false,
    postTripInspection: false,
    containersDesc: [],
    notes: [],
    clockIn: false,
    clockOut: false,
    location: [],
    dialog: false,
    vehicles: [],
    assignmentVehicle: false,
    selectedVehicle: null,
  }),
  methods: {
    today: function () {
      var este = this;
      este.$http
        .post(este.$api + "today", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
        })
        .then(function (response) {
          console.log(response);
          if (response.status == 200 && response.data.status == "ok") {
            if (response.data.results > 0) {
              console.log(response.data.data);
              este.forToday = true;
              este.numRoutes = response.data.data.numRoutes;
              este.numContainers = response.data.data.numContainers;
              este.numNotes = response.data.data.numNotes;
              este.notes = response.data.data.notes;
              este.preTripInspection = response.data.data.preTripInspection;
              este.postTripInspection = response.data.data.postTripInspection;
              este.clockIn = response.data.data.clockIn;
              este.clockOut = response.data.data.clockOut;
              este.containersDesc = response.data.data.containersDesc;
              este.$store.commit(
                "preTripInspection",
                response.data.data.preTripInspection
              );
              // Mostrar diálogo si hay más de 1 nota
              if (este.notes.length >= 1) {
                este.dialog = true;
              }
            } else {
              este.forToday = false;
            }
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    confirmTruck: function () {
      var este = this;
      este.$http
        .post(este.$api + "setTruck", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          truck: este.selectedVehicle,
        })
        .then(function (response) {
          console.log(response);
          if (response.status == 200 && response.data.status == "ok") {
            este.assignmentVehicle = true;
            let mensaje = {
              color: "green",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
          } else {
            let mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    clock: function (type) {
      var este = this;
      este
        .$getLocation()
        .then((coordinates) => {
          este.location = coordinates;
          este.$http
            .post(este.$api + "setClock", {
              driver_id: este.$store.getters.driver_id,
              token: este.$store.getters.token,
              type: type,
              location: este.location,
            })
            .then(function (response) {
              console.log(response);
              if (response.status == 200 && response.data.status == "ok") {
                if (response.data.results > 0) {
                  console.log(response.data.data);
                  if (type == 9) {
                    este.clockIn = true;
                    este.$store.commit("clockIn", true);
                  } else {
                    este.clockOut = true;
                    este.$store.commit("clockOut", true);
                  }
                } else {
                  este.forToday = false;
                }
              } else {
                var mensaje = {
                  color: "red",
                  timeout: 5000,
                  message: response.data.msg,
                };
                este.$store.commit("msgMuestra", mensaje);
                if (
                  "error" in response.data &&
                  response.data.error == "logout"
                ) {
                  este.$router.push("/logout");
                }
              }
            })
            .catch(function (err) {
              var mensaje = {
                color: "red",
                timeout: 5000,
                message: "There was an error. Please try again.",
              };
              este.$store.commit("msgMuestra", mensaje);
              window.console.log(err);
            });
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "We couldn't get your location. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
  },
  components: {},
  computed: {
    selectedTruck() {
      return this.vehicles.find((v) => v.id === this.selectedVehicle) || null;
    },
  },
  mounted: function () {
    if ([0, 6].includes(this.$moment().day())) {
      this.forToday = false;
    } else {
      // Consulta actividades para el día de hoy
      this.today();
    }
    this.$store.commit("title", "PRIMA");
    // Cargar los vehículos desde la API
    this.$http
      .post(this.$api + "vehicles", {
        driver_id: this.$store.getters.driver_id,
        token: this.$store.getters.token,
      })
      .then((res) => {
        // Verificar que la respuesta sea correcta
        if (res.status === 200 && res.data.status === "ok") {
          // Mapear los datos al formato que deseas
          this.vehicles = res.data.data;

          // Validar que res data assignments no esté vacío y siempre exista posición 0
          if (res.data.assignments && res.data.assignments.length > 0) {
            if (
              Number(this.$store.getters.driver_id) ===
              Number(res.data.assignments[0].driver_id)
            ) {
              this.selectedVehicle = res.data.assignments[0].vehicle_id;
              this.assignmentVehicle = true;
            }
          }

          console.log("Vehicles loaded:", this.vehicles);
        } else {
          console.error("Error loading vehicles:", res.data.msg || res.data);
        }
      })
      .catch((err) => {
        // Captura errores de la llamada HTTP
        console.error("HTTP error:", err);
      });
  },
};
</script>
